import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select";

// Connects to data-controller="tom-selected"
export default class extends Controller {
  static values = { 
    maxItems: Number,
    selected: Array
  }

  connect() {
    const maxItems = this.maxItemsValue;
    let items = JSON.parse(localStorage.getItem('contentIds') || '[]');
    
    // If there are new selected values, add them to the array.
    if (this.selectedValue) {
      items = [...items, ...this.selectedValue];
    
      // Remove duplicates by converting to a Set and then back to an Array
      items = Array.from(new Set(items));
    
      // Save the combined array back into local storage.
      localStorage.setItem('contentIds', JSON.stringify(items));
    }

    // Initialize TomSelect with items
    this.tomSelected = new TomSelect(this.element, {
      maxItems,
      items,
      plugins: ['remove_button'],
      render: {
        option: this.inputOption.bind(this),
      },
    });

    // Listen for changes and save to local storage
    this.tomSelected.on('change', () => {
      const items = this.tomSelected.getValue();
      localStorage.setItem('contentIds', JSON.stringify(items));
    });
  }

  inputOption(data, escape) {
    return `
      <div class="option">
        <span class="icon material-symbols-outlined">
          ${this.contentTypeIcon(data.$option.dataset.contentType)}
        </span>
        <span class="label">
          ${escape(data.text)}
        </span>
      </div>
    `;
  }

  disconnect() {
    this.tomSelected.destroy()
  }

  contentTypeIcon(contentType) {
    switch (contentType) {
      case 'images':
        return 'photo_library'
      case 'video':
        return 'movie'
      case 'audio':
        return 'headphones'
      case 'text':
        return 'article'
      default:
        return 'pages'
    }
  }
}